import Vue from 'vue';

export function formInit() {
  return Vue.axios({
    url: '/api/parentLeave/formInit',
    method: 'post',
  })
}

export function qiniuToken(data) {
  return Vue.axios({
    url: '/api/parentLeave/qiniuToken',
    method: 'post',
    data: data
  })
}

export function createLeave(data) {
  return Vue.axios({
    url: '/api/parentLeave/create',
    method: 'post',
    data: data
  })
}

export function listLeave(data) {
  return Vue.axios({
    url: '/api/parentLeave/list',
    method: 'post',
    data: data
  })
}

export function detailLeave(data) {
  return Vue.axios({
    url: '/api/parentLeave/detail',
    method: 'post',
    data: data
  })
}

export function supplementLeave(data) {
  return Vue.axios({
    url: '/api/parentLeave/supplement',
    method: 'post',
    data: data
  })
}

export function cancelLeave(data) {
  return Vue.axios({
    url: '/api/parentLeave/cancel',
    method: 'post',
    data: data
  })
}

export function addMessage(data) {
  return Vue.axios({
    url: '/api/parentLeave/addMessage',
    method: 'post',
    data: data
  })
}
